import { render } from "./DeleteReportsTableDialog.vue?vue&type=template&id=57005ca2"
import script from "./DeleteReportsTableDialog.vue?vue&type=script&lang=js"
export * from "./DeleteReportsTableDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__